import {
  withTranslation,
} from 'react-i18next';

import RegattaResultTilesSectionView from './RegattaResultTilesSectionView';

const TranslatedComponent = withTranslation()(RegattaResultTilesSectionView);

const Component = TranslatedComponent;

export default Component;
